import Vue from 'vue'
import 'shared/styles/index.css'

import VueTheMask, { TheMask, mask } from 'vue-the-mask'
import Notifications from 'vue-notification'
import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
import BlockUI from 'vue-blockui'

import axios from 'axios'

import i18n from './plugins/i18n'
import { store } from './plugins/store'
import globals from './plugins/globals'

import './components'

const core = {
  carregaEnum: true,
  defaultViews: true,
  store: store,
  api: {},
  extendEmpresa: () => {}
}

core.methods = {
  init: function (controllers, customControllers) {
    const favicon = document.getElementById('favicon')
    if (favicon) { favicon.href = require('shared/images/svg/favicon.svg') }

    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      store.commit('SET_USER_DATA', {
        user: userData
      })
    }

    core.api = require('./api').default
    core.api.init(controllers, customControllers)

    Vue.config.productionTip = false
    Vue.prototype.$api = core.api
    Vue.prototype.$store = store
    Vue.prototype.global = {
      GuidEmpty: '00000000-0000-0000-0000-000000000000'
    }

    Vue.use(VueTheMask)
    Vue.component(TheMask)
    Vue.directive('mask', {
      bind: function (el, binding) {
        el.setAttribute('data-mask', binding.value)
        mask(el, binding)
      }
    })

    Vue.use(Notifications)
    Vue.use(VueFileAgent)
    Vue.use(VueFileAgentStyles)
    Vue.use(BlockUI)

    Vue.mixin({
      data: globals,
      methods: {
        userHasRole (role) {
          if (role && this.$router) { return this.$router.userHasRole(role) } else { return true }
        }
      },
      computed: {
        $user: {
          get () {
            return core.store.getters.user
          }
        }
      }
    })

    core.methods.version()

    getEnum()
    getEmpresa()
  },
  version: function () {
    try {
      axios.get('/version.json').then(function (data) {
        const version = localStorage.getItem('appVersion')
        if (data.data.version && version !== data.data.version) {
          localStorage.setItem('appVersion', data.data.version)
          location.reload()
        }
      })
    } catch {}
  },
  finish (paths, theme, App) {
    if (!theme.options.compact) {
      theme.options.compact = {}
    }
    if (!theme.options.grid) {
      theme.options.grid = { pageSize: [5, 10, 15, 20, -1] }
    }
    if (!theme.options.breadcrumbs) {
      theme.options.breadcrumbs = {}
    }

    if (core.defaultViews) {
      const views = require('./plugins/router/default-paths.js').default

      views.forEach((p, i) => {
        if (!paths.some(o => o.view === p.view)) {
          p.props = {}
          if (theme.logo) { p.props.logoImage = theme.logo }
          if (theme.background) { p.props.backgroundImage = theme.background }
          paths.push(p)
        }
      })

      paths.forEach((p, i) => {
        if (!p) { return }

        if (core.defaultViews[p.view]) {
          p.props = core.defaultViews[p.view]
        }
      })
    }

    store.commit('paths', paths.filter(p => !!p))
    store.commit('theme', theme)

    const defaultTheme = {
      placeholder: ' ',
      placeholderSelect: 'Selecione',
      placeholderMultiSelect: 'Nenhum',
      placeholderCombobox: 'Digite ou Selecione',
      placeholderMultiCombobox: 'Nenhum',
      outlined: true,
      dense: true
    }
    theme.options = Object.assign(defaultTheme, theme.options)
    Vue.prototype.$theme = theme

    const vuetify = require('./plugins/vuetify').default
    var router = require('./plugins/router').default

    if (core.extendRouterBeforeEach) {
      router.extendRouterBeforeEach = core.extendRouterBeforeEach
    }
    if (core.extendRouterUserHasRole) {
      router.extendRouterUserHasRole = core.extendRouterUserHasRole
    }

    new Vue({
      i18n,
      router,
      vuetify,
      axios,
      render: h => h(App),
      created () {
      }
    }).$mount('#app')
  }
}
export default core

function getEnum () {
  if (core.carregaEnum) {
    // Carregar Arrays e Enums
    core.api.Enum.GetAll().then(function (response) {
      var items = Object.keys(response)
      core.api.Enums = {}
      core.api.Arrays = {}
      items.forEach(function (p) {
        core.api.Enums[p] = {}
        response[p].forEach(function (o) {
          core.api.Enums[p][o.name] = o.value
        })

        core.api.Arrays[p] = []
        response[p].forEach(function (o) {
          core.api.Arrays[p].push({
            value: o.value,
            text: o.description,
            name: o.name
          })
        })
      })
    })
  }
}
function getEmpresa () {
  // Carregar Variáveis de ambiente, thema
  let empresa = core.store.getters.empresa
  if (!empresa) {
    empresa = {
    }
  }

  core.extendEmpresa(empresa, function (data) {
    Vue.prototype.$empresa = data
    store.commit('empresa', data)
  })
}

// eslint-disable-next-line no-extend-native
String.prototype.regexIndexOf = function (regex, startpos) {
  var indexOf = this.substring(startpos || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
}

// eslint-disable-next-line no-extend-native
String.prototype.regexLastIndexOf = function (regex, startpos) {
  regex = (regex.global) ? regex : new RegExp(regex.source, 'g' + (regex.ignoreCase ? 'i' : '') + (regex.multiLine ? 'm' : ''));
  if (typeof (startpos) === 'undefined') {
    startpos = this.length;
  } else if (startpos < 0) {
    startpos = 0;
  }
  var stringToWorkWith = this.substring(0, startpos + 1);
  var lastIndexOf = -1;
  var nextStop = 0;
  var result
  while ((result = regex.exec(stringToWorkWith)) != null) {
    lastIndexOf = result.index;
    regex.lastIndex = ++nextStop;
  }
  return lastIndexOf;
}
